import { cn } from './cn';

/** Logotipo oficial entregado por el propietario (apps/web/public/brand/logo.png). */
export const OFFICIAL_LOGO = '/brand/logo.png';

/**
 * Logotipo de TuConductorRD. Se muestra sin alteraciones; sobre fondos
 * oscuros va dentro de una placa blanca para conservar sus colores originales.
 */
export function BrandLogo({ src, className, inverted }: { src?: string | null; className?: string; inverted?: boolean }) {
  const img = <img src={src || OFFICIAL_LOGO} alt="TuConductorRD" className={cn('h-8 w-auto', className)} draggable={false} />;
  if (!inverted) return img;
  return <span className="inline-flex items-center rounded-xl bg-white px-2.5 py-1.5 shadow-sm">{img}</span>;
}
